import { AbaPerfil } from '../models/aba-perfil.model';

export const TAMANHO_PAGINA_HISTORICO = 10;
export const TAMANHO_PAGINA_LEMBRETES = 10;
export const TAMANHO_PAGINA_LEMBRETES_HOJE = 5;
export const LIMIAR_PRE_CARGA_CARROSSEL = 2;
export const ORDEM_ABAS_PERFIL: AbaPerfil[] = ['detalhes', 'historico', 'lembretes'];
